import { AvviaPraticaRequest } from "@api/client";
import { praticaAvviaPratica } from "common/_redux/pratica/actions";
import BftButton from "common/components/button";
import BftCodeInput from "common/components/code-input";
import { TipoCondizionePraticaEnum } from "common/enums/pratica.enum";
import { codiceAttivazioneSchema } from "common/validators/validators";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch } from "core/store/hooks";
import { Formik } from "formik";
import { layoutUpdateStepsByService } from "layout/_redux/actions";
import { ChangeEvent, useState } from "react";
import { Card, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const title = "CODICE CONVENZIONE";
const subtitle = "INSERISCI IL CODICE CONVENZIONE CHE TI E' STATO FORNITO.";

const tipoProdottoOptions = [
	// {
	// 	id: "conto",
	// 	label: "Apertura conto",
	// 	value: "conto",
	// 	icon: "landmark",
	// },
	{
		id: "pos",
		label: "Richiesta POS",
		value: "pos",
		icon: "mobile-retro",
	},
];

const CodiceAttivazione: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const [choosePlan, setChoosePlan] = useState(false);
	const [tipoProdotto, setTipoProdotto] = useState<string>("");

	const handleTipoProdottoChange = (event: ChangeEvent<HTMLInputElement>) => {
		setTipoProdotto(event.currentTarget.value);
	};

	const handleChoosePlan = () => {
		setChoosePlan(!choosePlan);
		setTipoProdotto("");
	};

	const submitPlan = (tipoCondizione: TipoCondizionePraticaEnum) => {
		avviaPratica(tipoCondizione);
	};

	const goNext = () => {
		navigate(AppRouterService.get(PathEnum.cercaImpresa));
	};

	const _handleSubmit = (values: { codiceAttivazione: string; codiceDealer: string }) => {
		avviaPratica(values.codiceAttivazione, undefined, values.codiceDealer);
	};

	const avviaPratica = (
		activationCode: string,
		tipoCondizione?: TipoCondizionePraticaEnum,
		codiceDealer?: string
	) => {
		let request: AvviaPraticaRequest = {
			codiceAttivazione: activationCode && activationCode,
			// tipoCondizione: tipoCondizione,
			dealer: codiceDealer ? codiceDealer : undefined,
			isFidoTest: true,
		};

		dispatch(praticaAvviaPratica(request))
			.unwrap()
			.then((res) => {
				if (
					res &&
					res.codicePratica &&
					res.tipoServizio &&
					res?.codicePratica?.length > 0 &&
					res.tipoServizio?.length > 0
				) {
					dispatch(layoutUpdateStepsByService(res.tipoServizio));
					goNext();
				}
			});
	};

	return (
		<>
			<Formik
				initialValues={{ codiceAttivazione: "", codiceDealer: "" }}
				onSubmit={_handleSubmit}
				validationSchema={codiceAttivazioneSchema}
			>
				{({ errors, values, touched, handleChange, handleSubmit }) => {
					return (
						<Card className="shadow">
							<Card.Body>
								<h4 className="container my-3 fs-4">{title}</h4>

								<form onSubmit={handleSubmit}>
									<Row>
										<div className="mx-3 mb-3">
											<span className="gray m-0 fs-5">{subtitle}</span>
										</div>
										<div className="mb-3 col-xxl-6 col-xl-12 col-lg-12 ms-lg-3">
											<div className="d-flex">
												<i className="fa-solid fa-pen-to-square icon-pen-attiv me-3 fs-1"></i>
												<BftCodeInput
													length={7}
													id={"codiceAttivazione"}
													key={"codiceAttivazione"}
													placeholder={"Codice Convenzione"}
													codeHandler={(code) => {
														handleChange("codiceAttivazione")(code);
														handleChange("codiceDealer")("");
													}}
													inputCode={values.codiceAttivazione.toUpperCase()}
													isInvalid={!!errors.codiceAttivazione && touched.codiceAttivazione}
													autofocus
												/>
											</div>

											{errors.codiceAttivazione && touched.codiceAttivazione && (
												<Form.Control.Feedback className="my-0" type="invalid">
													{errors.codiceAttivazione}
												</Form.Control.Feedback>
											)}
										</div>

										<BftButton
											type="submit"
											className="btn-buffetti col-xxl-2 col-xl-3 col-8 mx-3 mb-3"
											style={{ height: "calc(3.5rem + 2px)", width: "150px" }}
											isDisabled={
												values.codiceAttivazione.length < 7 ||
												(values.codiceAttivazione.substring(2, 4).toUpperCase() === "OL" &&
													values.codiceDealer.length < 3)
											}
										>
											Avanti
										</BftButton>
									</Row>
								</form>

								{values.codiceAttivazione.substring(2, 4).toUpperCase() === "OL" && (
									<div>
										<div className="mx-3 mb-3">
											<span className="gray m-0 fs-5">INSERISCI IL CODICE DEL TUO DEALER</span>
										</div>
										<div className="mb-3 col-xxl-4 col-xl-12 col-lg-12">
											<div className="d-flex">
												<i className="fa-solid fa-pen-to-square icon-pen-attiv me-3 fs-1 ms-3"></i>

												<BftCodeInput
													length={3}
													id={"codiceDealer"}
													key={"codiceDealer"}
													placeholder={"Codice Dealer"}
													codeHandler={handleChange("codiceDealer")}
													inputCode={values.codiceDealer}
													isInvalid={!!errors.codiceDealer && touched.codiceDealer}
												/>
											</div>

											{errors.codiceDealer && touched.codiceDealer && (
												<Form.Control.Feedback className="my-0 ms-3" type="invalid">
													{errors.codiceDealer}
												</Form.Control.Feedback>
											)}
										</div>
									</div>
								)}

								{/* <div className="ms-3">
									<span className="gray m-0">Non hai un codice di attivazione? </span>
									<span
										style={{ cursor: "pointer", color: "#1a73e8" }}
										className="m-0"
										onClick={handleChoosePlan}
									>
										Clicca qui{" "}
										{choosePlan ? (
											<i
												className="fa-solid fa-caret-up"
												style={{ cursor: "pointer", color: "#1a73e8" }}
											></i>
										) : (
											<i
												className="fa-solid fa-caret-down"
												style={{ cursor: "pointer", color: "#1a73e8" }}
											></i>
										)}
									</span>

									{choosePlan && (
										<div className="col-12 mt-3">
											<BtfOptionGroup
												controlId="tipoProdotto"
												options={tipoProdottoOptions}
												onChange={handleTipoProdottoChange}
												selectedOption={tipoProdotto}
											/>
										</div>
									)}
								</div> */}
							</Card.Body>
						</Card>
					);
				}}
			</Formik>

			{/* {choosePlan && tipoProdotto === "conto" && <PianoConto submitPlan={submitPlan} />}
			{choosePlan && tipoProdotto === "pos" && <PianoPos submitPlan={submitPlan} />} */}
		</>
	);
};

export default CodiceAttivazione;
